import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-product-list",
  "use": "icon-product-list-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-product-list\"><defs><style type=\"text/css\"></style></defs><path d=\"M509.717333 106.666667a192 192 0 0 1 192 192h119.466667a32 32 0 0 1 31.914667 29.802666l38.250666 554.666667A32 32 0 0 1 859.434667 917.333333H160a32 32 0 0 1-31.914667-34.197333l38.250667-554.666667A32 32 0 0 1 198.250667 298.666667h119.466666a192 192 0 0 1 192-192z m-173.525333 478.122666a32 32 0 0 0-26.730667 49.6A234.517333 234.517333 0 0 0 509.717333 746.666667c84.757333 0 159.018667-44.928 200.256-112.277334a32 32 0 0 0-54.613333-33.408A170.56 170.56 0 0 1 509.738667 682.666667a170.56 170.56 0 0 1-145.642667-81.664 32.085333 32.085333 0 0 0-27.882667-16.213334zM509.717333 170.666667a128 128 0 0 0-128 128h256a128 128 0 0 0-128-128z\" fill=\"#ffffff\" p-id=\"16282\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/product-list.svg
// module id = qzoa
// module chunks = 115